'use strict'
module.exports = {
  BASE_PATH: '/',
  BACKEND_URL: 'https://services.conasi.vn/apartment/',
  GROUP_CHANNEL: {
    name: 'group_channel_',
    check_notification: 'send_push_notification',
    ws: "ws"
  },
  MEDIA_AGENT_URL: 'https://services.conasi.vn/media/',
  MEDIA_AGENT_KEY: 'm4lSgv_RlJs3e3QqQktUP5Hu1nxyADb1mtL8XwxsDyAuQxpGUS4ZK4ZeKaM0u09Er69JF1nCA-5aE5PyM3mVSP0-Ew3_KyMGaePYBFtHzlaUJO7sKph-MfIGmIwyqFfUPBvSz62IQRLiyIHrviT1fiqtX568-DPBLXc7eH5Pv8U=',
  SITE_NAME_INFO: 2
};



//////////////////
// WEBPACK FOOTER
// ./build/config.js
// module id = c0zf
// module chunks = 0